/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import '../common';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "onboard": {
        "nested": {
          "activation": {
            "nested": {
              "ca": {
                "nested": {
                  "common": {
                    "nested": {
                      "Persona": {
                        "fields": {
                          "firstName": {
                            "type": "string",
                            "id": 1,
                            "rule": "optional"
                          },
                          "lastName": {
                            "type": "string",
                            "id": 2,
                            "rule": "optional"
                          },
                          "socialInsuranceNumber": {
                            "type": "string",
                            "id": 3,
                            "rule": "optional"
                          },
                          "phoneNumber": {
                            "type": "string",
                            "id": 4,
                            "rule": "optional"
                          },
                          "birthDate": {
                            "type": ".squareup.onboard.activation.common.BirthDate",
                            "id": 5,
                            "rule": "optional"
                          },
                          "fullSinFideliusToken": {
                            "type": "string",
                            "id": 6,
                            "rule": "optional"
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.onboard?.nested?.activation?.nested?.ca?.nested?.common?.nested?.Persona) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE Persona @ squareup/onboard/activation/ca/common.proto at 22:1
 */
export const Persona = $root.lookupType('squareup.onboard.activation.ca.common.Persona');
fixType(Persona, {
  firstName: {
    required: true
  },
  lastName: {
    required: true
  },
  phoneNumber: {
    required: true
  },
  birthDate: {
    required: true
  }
});
Builder.createAndAttachToType(Persona);